import React, { useEffect, useState } from "react";
import { MarketBasketItem, Price } from "./MarketModal";
import { backbutton, clock, poweredBy, rightArrow } from "./svgs";
import {
  calculateTotalPrice,
  formatCurrency,
  formatNameService,
  formatPrice,
  formatPriceTotal,
  formatPriceTotalConfirm,
} from "./MarketSearchResult";
import MarketHeroCard from "./MarketHeroCard";
import { minus, plus, emailLogo, userLogo, globeLogo, web2Logo } from "./svgs";
import { priceConversion } from "./MarketSearchPage";
import useFitText from "use-fit-text";

interface MarketConfirmPageProps {
  basket: MarketBasketItem | undefined;
  userInfo: any;
  increaseYears: () => void;
  decreaseYears: () => void;
  confirm: () => void;
  setHeight: (height: any) => void;
  back: () => void;
  seconds: number,
  currencyEstimates: [
    {
      symbol: string;
      name: string;
      exhangeRate: number;
    }
  ];
}

const MarketConfirmPage: React.FC<MarketConfirmPageProps> = ({
  basket,
  userInfo,
  confirm,
  increaseYears,
  decreaseYears,
  setHeight,
  back,
  currencyEstimates,
  seconds,
}) => {
  let widthStyle = "100%"; // default

  const { fontSize, ref } = useFitText();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setHeight(basket?.nameService == "icann" || basket?.nameService == "ens" ? 750: 565)
  },[])

  const handleClick = () => {
    if(animate) return
    setAnimate(true);
    setTimeout(() => setAnimate(false), 2000); // This will remove the class after the animation completes
  };

  if (navigator.userAgent.includes("Firefox")) {
    widthStyle = "-moz-available";
  } else if (
    navigator.userAgent.includes("Chrome") ||
    navigator.userAgent.includes("Safari")
  ) {
    widthStyle = "-webkit-fill-available";
  } else {
    widthStyle = "fill-available";
  }

  const modalContentStyle: React.CSSProperties = {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    background: "rgba(248, 248, 248, 1)",
    width: widthStyle,
    justifyContent: "left",
    alignItems: "left",
    alignContent: "left",
  };

  const topStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#000000",
    fontSize: "16px",
    fontFamily: "GT Planar Medium",
    gap: 10,
    padding: 24,
    paddingTop: 32,
    paddingBottom: 10,
  };

  const bottomStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(248, 248, 248, 1)",
    gap: 20,
    width: widthStyle,
    fontSize: "14px",
    paddingTop: 24,
    paddingRight: 24,
    paddingLeft: 24,
    paddingBottom: 8,
    zIndex: 2,
  };

  const backButtonStyle: React.CSSProperties = {
    justifyContent: "center",
    cursor: "pointer",
    alignItems: "center",
    paddingTop: 4,
    width: 32,
    height: 32,
    background: "rgba(0, 0, 0, 0.05)",
    borderRadius: 12,
    border: "none",
    color: "#000000",
  };

  const yearButtonStyle: React.CSSProperties = {
    justifyContent: "center",
    cursor: "pointer",
    alignItems: "center",
    paddingTop: 4,
    boxShadow:
      "0px 122.973px 98.3784px rgba(0, 0, 0, 0.07), 0px 51.3752px 41.1001px rgba(0, 0, 0, 0.0503198), 0px 27.4676px 21.9741px rgba(0, 0, 0, 0.0417275), 0px 15.3981px 12.3185px rgba(0, 0, 0, 0.035), 0px 8.17783px 6.54226px rgba(0, 0, 0, 0.0282725), 0px 3.40298px 2.72238px rgba(0, 0, 0, 0.0196802)",
    width: 32,
    height: 32,
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 10000,
    border: "none",
    color: "#000000",
  };

  const searchButtonStyle: React.CSSProperties = {
    flex: "0 0 auto",
    paddingTop: 4,
    cursor: "pointer",
    height: 48,
    background: "linear-gradient(108.64deg, #854EFB 7.51%, #8A88FF 98.44%)",
    boxShadow:
      "0px 122.973px 98.3784px rgba(0, 0, 0, 0.07), 0px 51.3752px 41.1001px rgba(0, 0, 0, 0.0503198), 0px 27.4676px 21.9741px rgba(0, 0, 0, 0.0417275), 0px 15.3981px 12.3185px rgba(0, 0, 0, 0.035), 0px 8.17783px 6.54226px rgba(0, 0, 0, 0.0282725), 0px 3.40298px 2.72238px rgba(0, 0, 0, 0.0196802)",
    borderRadius: 12,
    border: "1.5px solid #8A88FF",
    color: "#FFFFFF",
    width: widthStyle,
  };

  const domainStyle: (fontSize: string) => React.CSSProperties = (fontSize) => {
    return {
          fontFamily: "GT Planar Medium",
          fontSize,
    }
  };

  const totalStyle: React.CSSProperties = {
    color: "rgba(0, 0, 0, 0.9)",
    fontSize: "20px",
  };

  return (
    <div style={modalContentStyle}>
      <div style={topStyle}>
        <button onClick={back} style={backButtonStyle}>
          {" "}
          {backbutton}
        </button>
        <div>You're ready to name</div>
      </div>
      <div style={{ height: "100%", overflow: "visible"}} className="animparent">
        <div
          style={{
            fontSize: "32px",
            paddingLeft: 24,
          }}
        >
          {userInfo.walletAddress}
        </div>
        <div  onClick={handleClick} className={animate ? 'animate' : ''} style={{ position: "relative", height: 150 }}>
          <MarketHeroCard
            domain={basket?.domain || ""}
            avatarUrl={undefined}
            backgroundUrl="https://assets.superlink.me/backgrounds/58d9d9ef-313b-4e81-8908-cc23bb251bfa"
            containerStyle={{ left: 25, top: 20, width: 370, height: 350 }}
            walletAddress={userInfo.walletAddress}
          />
        </div>
      </div>
      <div style={bottomStyle}>
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 20,
              justifyContent: "space-between",
              width: widthStyle,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flex: "0 0 auto",
                  flexDirection: "row",
                  alignContent: 'center',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div ref={ref} style={domainStyle(fontSize)}>{basket?.domain || ""}</div>
                {basket?.currency != "USD" && <div style={{
                                    display: "flex",
                                    color: "rgba(0, 0, 0, 0.7)",
                                    fontSize: "12px",
                                    flexDirection: "row",
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    gap: 5,
                                    paddingRight: 12
                }}>{clock} Quotes update in <span style={{width: 5}}>{seconds}s</span></div>}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 8,
                }}
              >
                {formatNameService(basket?.nameService || "")}
                {basket?.features.includes("web2") && (
                  <div
                    style={{
                      display: "flex",
                      gap: 5,
                      background: "rgba(0, 0, 0, 0.05)",
                      borderRadius: "24px",
                      padding: "4px 12px 4px 12px",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {web2Logo} Web2
                  </div>
                )}
                {basket?.features.includes("web3") && (
                  <div
                    style={{
                      display: "flex",
                      gap: 5,
                      background: "rgba(0, 0, 0, 0.05)",
                      borderRadius: "24px",
                      padding: "4px 12px 4px 12px",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {globeLogo} Web3
                  </div>
                )}
                {basket?.features.includes("email") && (
                  <div
                    style={{
                      display: "flex",
                      gap: 5,
                      background: "rgba(0, 0, 0, 0.05)",
                      borderRadius: "24px",
                      padding: "5px",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {emailLogo}
                  </div>
                )}
                {basket?.features.includes("userId") && (
                  <div
                    style={{
                      display: "flex",
                      gap: 5,
                      background: "rgba(0, 0, 0, 0.05)",
                      borderRadius: "24px",
                      padding: "5px",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {userLogo}
                  </div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.7)",
                  gap: 20,
                  justifyContent: "space-between",
                  width: widthStyle,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                }}
              >
                { basket?.nameService == "ens" ? 
                  <p style={{ marginTop: 0 }}>
                    ENS domains are compatible with <span style={{ color: "rgba(41, 155, 128, 1)" }}>
                    all major wallets
                    </span> and over <span style={{ color: "rgba(41, 155, 128, 1)" }}>
                      500 services
                    </span>. They are the most widely accepted web3 address
                  </p>
                : null}
                { basket?.nameService == "ud" ? 
                  <p style={{ marginTop: 0 }}>
                    Unstoppable Domains are compatible with <span style={{ color: "rgba(41, 155, 128, 1)" }}>
                    150+ wallets
                    </span> and <span style={{ color: "rgba(41, 155, 128, 1)" }}>
                    1,000+ integrations
                    </span>. Own it forever, instead of a yearly payment. Works with Opera and Brave browsers.
                  </p>
                : null}
                { basket?.nameService == "superlink" ? 
                  <p style={{ marginTop: 0 }}>
                    Superlink names are compatible with a select but growing number of <span style={{ color: "rgba(41, 155, 128, 1)" }}>
                    wallets
                    </span>, including this one. They are the cleanest, simplest digital ID. Just you, nothing else!
                  </p>
                : null}
                { basket?.nameService == "icann" ? 
                  <p style={{ marginTop: 0 }}>
                    With an ENS bridge, web2 domains are your very own <span style={{ color: "rgba(41, 155, 128, 1)" }}>
                    payment address, website, and email domain
                    </span> - all in one! Just like ENS, they are compatible with <span style={{ color: "rgba(41, 155, 128, 1)" }}>
                    all major wallets
                    </span> and over <span style={{ color: "rgba(41, 155, 128, 1)" }}>
                      500 services
                    </span>.
                  </p>
                : null}
              </div>
            </div>
          </div>
        </div>

        {/* Setup */}
        {(basket?.nameService == "ens") && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 15,
              justifyContent: "space-between",
              width: widthStyle,
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              paddingBottom: "20px",
            }}
          >
            <div style={{ color: "rgba(0, 0, 0, 0.7)" }}>Setup</div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                gap: 15,
              }}
            >
              {formatCurrency(convertPrice(basket.currency, basket.price, currencyEstimates).ens_setup_gas, basket.currency, "US")} one-time
            </div>
          </div>
        )}

        {(basket?.nameService == "icann") && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 15,
              justifyContent: "space-between",
              width: widthStyle,
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              paddingBottom: "20px",
            }}
          >
            <div style={{ color: "rgba(0, 0, 0, 0.7)" }}>Setup</div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                gap: 15,
              }}
            >
              {formatCurrency(convertPrice(basket.currency, basket.price, currencyEstimates).ens_bridge, basket.currency, "US")} one-time
            </div>
          </div>
        )}

        {/* Subscription */}
        {(basket?.nameService == "ens") && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 15,
              justifyContent: "space-between",
              width: widthStyle,
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              paddingBottom: "20px",
            }}
          >
            <div style={{ color: "rgba(0, 0, 0, 0.7)" }}>Subscription</div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                gap: 15,
              }}
            >
              {formatCurrency(convertPrice(basket.currency, basket.price, currencyEstimates).ens_rent, basket.currency, "US")} / yr
            </div>
          </div>
        )}

        {(basket?.nameService == "icann") && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 15,
              justifyContent: "space-between",
              width: widthStyle,
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              paddingBottom: "20px",
            }}
          >
            <div style={{ color: "rgba(0, 0, 0, 0.7)" }}>Subscription</div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                gap: 15,
              }}
            >
              {formatCurrency(convertPrice(basket.currency, basket.price, currencyEstimates).renewal, basket.currency, "US")} / yr
            </div>
          </div>
        )}

        {/* Years */}
        {(basket?.nameService == "ens" || basket?.nameService == "icann") && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 15,
              justifyContent: "space-between",
              width: widthStyle,
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              paddingBottom: "20px",
            }}
          >
            <div style={{ color: "rgba(0, 0, 0, 0.7)" }}>Years</div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                gap: 15,
              }}
            >
              <button style={yearButtonStyle} onClick={decreaseYears}>
                {minus}
              </button>
              <div style={{ minWidth: "55px" }}>
                {basket?.years || ""} years
              </div>
              <button style={yearButtonStyle} onClick={increaseYears}>
                {plus}
              </button>
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: widthStyle,
            paddingBottom: "20px",
          }}
        >
          <div style={{}}>
            <div style={{ color: "rgba(0, 0, 0, 0.7)" }}>Total</div>
          </div>
          <div style={totalStyle}>
            {basket &&  formatPriceTotalConfirm(basket.nameService, convertPrice(basket.currency, basket.price, currencyEstimates), basket.currency, "US", basket.years)}
          </div>
        </div>
      </div>
      <div
        style={{
          paddingLeft: 24,
          paddingRight: 24,
          paddingBottom: 15,
        }}
      >
        <button onClick={confirm} style={searchButtonStyle}>
          <div
            style={{
              gap: 5,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Checkout {rightArrow("white")}
          </div>
        </button>
      </div>
      <div
        style={{
          flex: "0 0 auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: 25.5,
        }}
      >
        {poweredBy}
      </div>
    </div>
  );
};

export const doConv = (
  currency: string,
  price: Price, 
  nameService: string,
  years: number,
  region: string,
  currencyEstimates: [
    {
      symbol: string;
      name: string;
      exhangeRate: number;
    }
  ]
) => {
  const e = currencyEstimates.filter((x: any) => {
    return x.symbol.toUpperCase() == currency.toUpperCase();
  })[0]?.exhangeRate;
  var p = price;
  if (e) {
    p = priceConversion(price, e);
  }

  return formatCurrency(
    calculateTotalPrice(nameService, p, years),
    currency,
    region
  );
};

export const convertPrice = (
  currency: string,
  price: Price, 
  currencyEstimates: [
    {
      symbol: string;
      name: string;
      exhangeRate: number;
    }
  ]
): Price => {
  const e = currencyEstimates.filter((x: any) => {
    return x.symbol.toUpperCase() == currency.toUpperCase();
  })[0]?.exhangeRate;
  if (e) {
    return priceConversion(price, e);
  }
  return price
};


export default MarketConfirmPage;
